/**
 * Visible-field match for Recherche results.
 * Backend may match hidden fields (description, pitch, etc.) — we only keep
 * items where the query appears in text shown on the card.
 */

function asText(value) {
  if (value == null) return "";
  if (typeof value === "object") {
    return value.name || value.title || value.label || "";
  }
  return String(value);
}

function expertName(expert) {
  if (!expert) return "";
  if (expert.full_name) return expert.full_name;
  return `${expert.first_name || ""} ${expert.last_name || ""}`.trim();
}

function organiserName(item) {
  const org = item?.organisateur;
  if (!org) return "";
  if (typeof org === "string") return org;
  if (Array.isArray(org) && org.length) {
    const first = org[0];
    if (typeof first === "string") return first;
    return first?.name || first?.title || "";
  }
  return org?.name || org?.title || "";
}

function visibleFieldsForType(item, type) {
  switch (type) {
    case "news":
      return [
        item.title,
        item.retenir,
        item.resume,
        item.description,
        asText(item.category || item.Categorie),
        expertName(item.expert),
      ];
    case "opinion":
      return [
        item.title,
        item.retenir,
        item.resume,
        item.description,
        asText(item.category || item.Categorie),
        expertName(item.expert),
      ];
    case "formation":
    case "masterclass":
      return [
        item.title,
        asText(item.category || item.Categorie),
        organiserName(item),
        asText(item.level),
      ];
    case "module":
      return [
        item.title,
        asText(item.category),
        item.formation?.title,
        item.formation?.name,
        item.masterclass?.title,
        item.masterclass?.name,
        asText(item.level),
      ];
    case "event":
      return [
        item.title,
        asText(item.type),
        item.location_city,
        item.location_pays,
        item.participation,
        item.event_nature || item.nature,
      ];
    case "library":
      return [
        item.name,
        item.title,
        asText(item.category),
        item.file_type,
      ];
    case "expert":
      return [
        expertName(item),
        item.resume,
        item.city,
        asText(item.profession),
      ];
    case "institution":
      return [
        item.name,
        item.abbreviation,
        item.city,
        item.resume,
        asText(item.organization_type),
      ];
    default:
      return [item.title, item.name];
  }
}

export function itemMatchesVisibleQuery(item, type, query) {
  const raw = (query || "").trim().toLowerCase();
  if (raw.length < 2) return true;

  const tokens = [
    ...new Set(
      raw
        .split(/\s+/)
        .map((t) => t.trim())
        .filter((t) => t.length >= 2),
    ),
  ];
  if (!tokens.length) return true;

  const haystack = visibleFieldsForType(item, type)
    .map((v) => asText(v).toLowerCase())
    .filter(Boolean)
    .join(" ");

  return tokens.every((token) => haystack.includes(token));
}

export function filterVisibleMatches(items, type, query) {
  if (!Array.isArray(items)) return [];
  return items.filter((item) => itemMatchesVisibleQuery(item, type, query));
}
